<template lang='pug'>
v-main
  nav.navbar.navbar-light.bg-light
    span.navbar-text
      h5 Dev/Debug page
  .list-group
    p.list-group-item click2call: {{ click2call }}

  .list-group(v-if='isCordova')
    p.list-group-item Cordova is available

  .list-group(v-else)
    p.list-group-item Cordova is not available

  .list-group
    p.list-group-item Logged in user: {{ user.username }}

  
</template>

<script >
import Common from "../mixins/common.vue";

/* global cordova */
  export default {
    mixins: [Common],
    data: function() {
      let c = typeof cordova !== 'undefined';
      return ({
        isCordova: !c ? null : global.cordova,
      });
    },
  }
</script>